import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "SizeMin",
  "use": "SizeMin-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"SizeMin\"><path fill-rule=\"evenodd\" d=\"M10.452.032v10.285H0V5.175h5.226V0l5.226.032zm15.096 0L30.774 0v5.175H36v5.142H25.548V.032zM10.452 35.429l-5.226.031v-5.174H0v-5.143h10.452v10.286zm15.096 0V25.143H36v5.143h-5.226v5.174l-5.226-.031z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol